export const contractStatusIds: ContractStatuses = {
  open: 'f08db0a2-a32c-4267-90fb-07e4cf34491e',
  closed: 'a264eb8f-0bd5-471a-87d9-5e01a5e81c46'
};

class ContractStatuses {
  open: string;
  closed: string;
}
